
  import { defineComponent, onMounted, reactive, ref, nextTick, onActivated, watch, toRefs, computed } from 'vue'
  import { addCarsApply, queryAllDept, getUserBasicInfo, queryAllEntrance, getOpenId } from '@/apis/comm/api'
  import router from '@/router'
  import { useRoute, useRouter } from 'vue-router'
  import { showSuccessToast, showToast } from 'vant'
  import { GetQueryString, ToWechat } from '@/utils/index'
  import { useToken, useInfoUser } from '@/hooks/storage'
  import _ from 'lodash'

  export default defineComponent({
    name: 'applyfor',
    setup() {
      onMounted(() => {
        nextTick(() => {
          var u = navigator.userAgent
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isiOS) {
            window.onpageshow = function (event) {
              if (event.persisted) {
                window.location.reload()
              }
            }
          }
        })
        const route = useRoute()
        info.form.visiStartTime = info.formatter(null)

        info.code = GetQueryString('code')
        if (info.code) {
          info.getUserID()
        } else {
          let openId = window.sessionStorage.getItem('openId')
          if (openId) {
            info.form.openId = openId
            info.openid = openId
            info.getUserInfo()
            info.getAllDeptment()
            info.getEntranceData()
          } else if (useToken().get()) {
            let user = JSON.parse(useInfoUser().get())
            info.form.openId = user.gh
            info.openid = user.gh
            info.getAllDeptment()
            info.getEntranceData()
          } else {
            ToWechat('pub/apply')
          }
        }
      })
      const mintime = computed(() => {
        return info.form.startTime.join('') ? info.form.startTime.join(':') : ''
      })

      const formRef = ref(null)
      const info = reactive({
        keyvalue: '',
        code: '' as any,
        username: '',
        form: {
          openId: '',
          beAccessOrgId: '',
          beAccessOrgName: '',
          visiCampus: '', //访问校区
          entranceName: [],
          visiStartTime: '', // 默认选中当天日期
          // startTime: ['', '', ''],
          // endTime: ['', '', ''],
          visitorName: '',
          visitorPhone: '',
          carsRecordList: [
            {
              plateNum: '', //车牌号
              visitorName: '', //车主姓名
              visitorPhone: '' //联系电话
            }
          ],
          reason:'',
          applyType: 1
        } as any,
        InterUnitShow: false,
        InterUnits: [],
        InterUnitss: [],
        InterXQ: false,
        InterXQs: [{ name: '草堂校区' }, { name: '雁塔校区' }],
        CTEntrances: [],
        YTEntrances: [],
        InterEntranceShow: false,
        StartTimeShow: false,
        EndTimeShow: false,
        InterEntrances: [],
        copyArr: [],
        calendarShow: false,
        openid: '' as any,
        submit_loading: false,
        getUserID: async () => {
          const res = await getOpenId(info.code)
          info.form.openId = res.data.data.openid
          info.openid = res.data.data.openid

          window.sessionStorage.setItem('openId', info.openid)
          info.getUserInfo()
          info.getAllDeptment()
          info.getEntranceData()
        },
        getAllDeptment: async () => {
          const { data } = await queryAllDept({ openId: info.openid })
          info.InterUnits = data.data.map(item => {
            return { text: item.orgName, value: item.orgId }
          })
          info.InterUnitss = [...info.InterUnits]
        },
        getEntranceData: async () => {
          const { data } = await queryAllEntrance('JD_caotang_campus')
          info.CTEntrances = data.data.map(item => {
            return item.dictLabel
          })
          const { data: data1 } = await queryAllEntrance('JD_yanta_campus')
          info.YTEntrances = data1.data.map(item => {
            return item.dictLabel
          })
        },
        getUserInfo: async () => {
          let openId = window.sessionStorage.getItem('openId')
          const { data } = await getUserBasicInfo({
            openId: openId
          })
          if (data.code == 200) {
            info.form.visitorName = data?.data.fullName
            info.form.visitorPhone = data?.data.phone
          }
        },
        showorg() {
          info.InterUnitShow = true
          info.keyvalue = ''
        },

        search() {
          if (info.keyvalue) {
            info.InterUnitss = info.InterUnits.filter(params => {
              return params.text.includes(info.keyvalue)
            })
          } else {
            info.InterUnitss = info.InterUnits
          }
        },
        InterUnitConfirm({ selectedOptions, selectedValues }) {
          info.form.beAccessOrgId = selectedValues.join(',')
          info.form.beAccessOrgName = selectedOptions[0].text
          info.InterUnitShow = false
        },
        interXQSelect(item: { name: any }) {
          if (item.name != info.form.visiCampus) {
            info.form.visiCampus = item.name
            info.form.entranceName = item.name === '草堂校区' ? info.CTEntrances : info.YTEntrances
          }
        },
        openEntrancePicker: async () => {
          if (!info.form.visiCampus) return showToast('请选择校区')
          info.InterEntrances = info.form.visiCampus === '草堂校区' ? info.CTEntrances : info.YTEntrances
          info.copyArr = _.cloneDeep(info.form.entranceName)
          info.InterEntranceShow = true
        },
        InterEntranceCancel() {
          nextTick(() => {
            info.copyArr = []
          })
          info.InterEntranceShow = false
        },
        InterEntranceConfirm() {
          info.form.entranceName = info.copyArr
          info.InterEntranceShow = false
          info.copyArr = []
        },
        confirmMultiplePicker(val) {
          const arr = info.copyArr
          if (arr.indexOf(val) !== -1) {
            // 若已经选择过 则取消选择
            info.copyArr = info.copyArr.filter(v => v !== val)
          } else {
            info.copyArr.push(val)
          }
        },
        delInformation(val) {
          info.form.entranceName = info.form.entranceName.filter(v => v !== val)
        },
        calendarConfirm(event: any) {
          let a: any = info.formatter(event)
          info.form.visiStartTime = a
          info.calendarShow = false
        },
        filterTime(type, options, values) {
          if (type === 'minute') {
            options = options.filter(option => Number(option.value) === 0)
          }
          if (type === 'second') {
            options = options.filter(option => Number(option.value) === 0)
          }
          return options
        },
        addACar() {
          let car = {
            plateNum: '',
            visitorName: '',
            visitorPhone: ''
          }
          info.form.carsRecordList.push(car)
        },
        delACar(i: number) {
          info.form.carsRecordList.splice(i, 1)
        },
        submit: async () => {
          try {
            const vaild = await (formRef.value as any).validate()
            // if (!info.form.entranceName.length) return showToast("请选择入场口");
            // if (!info.form.startTime.join('')) return showToast('请选择开始时间')
            // if (!info.form.endTime.join('')) return showToast('请选择结束时间')
            if (!vaild) {
              info.submit_loading = true
              info.form.approvalState = '5'
              let query = _.cloneDeep(info.form)
              query.visiStartTime = `${info.form.visiStartTime} 00:00:00`
              // query.visiEndTime = `${info.form.visiStartTime} ${query.endTime.join(':')}`
              query.entranceName = query.entranceName.join(',')
              const res = await addCarsApply(query)
              info.submit_loading = false
              if (res.data.code == 200) {
                showSuccessToast('提交成功')
                if (useToken().get()) {
                  router.go(-1)
                } else {
                  router.replace({
                    path: '/'
                  })
                }
              }
            }
          } catch (error) {
            info.submit_loading = false
            console.log('提交失败：' + error)
          }
        },
        // 日期组件自定义格式
        formatter(time: any) {
          let nowdata = time == null ? new Date() : new Date(time)
          let year = nowdata.getFullYear()
          let month = nowdata.getMonth() + 1
          let date = nowdata.getDate()
          let nowtime = year + '-'
          if (month < 10) {
            nowtime += '0'
          }
          nowtime += month + '-'
          if (date < 10) {
            nowtime += '0'
          }
          nowtime += date

          return nowtime
        }
      })
      watch(
        () => info.keyvalue,
        (newval, oldval) => {
          if (newval) {
            info.InterUnitss = info.InterUnits.filter(params => {
              return params.text.includes(info.keyvalue)
            })
          } else {
            info.InterUnitss = info.InterUnits
          }
        }
      )
      return { info, formRef, mintime }
    }
  })
